export default __webpack_public_path__ + "static/media/envelope-solid.ed75e150.svg";